<template>
  <b-card>
    <titleSection
      title="Información de contacto"
      subtitle="Datos personales de registro"
      icon="UserIcon"
    />

    <validation-observer ref="form">
      <b-form>
        <!-- DATOS DE CONTACTO -->
        <b-row class="mt-2">
          <!-- MESSAGE -->
          <b-col md="12">
            <b-alert
              variant="primary"
              show
            >
              <div class="alert-body">
                <p>Es importante que los datos personales “Nombre(s)” y “Apellido(s)” coincidan con una identificación oficial (IFE, INE o Pasaporte).</p>
                <p>Los campos <strong>correo electrónico</strong> y <strong>CURP</strong>, no permiten el copiado y pegado de datos, es necesario ingresarlos de manera manual.</p>
              </div>
            </b-alert>
          </b-col>

          <!-- NOMBRE -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="nombre"
                rules="required|min:3|alpha_spaces"
              >
                <b-form-input
                  v-model="formulario.nombre"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Nombre"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- SEGUNDO NOMBRE -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="segundo nombre"
                rules="min:3|alpha_spaces"
              >
                <b-form-input
                  v-model="formulario.segundoNombre"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Segundo nombre"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- APELLIDO PATERNO -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="apellido paterno"
                rules="required|min:2|alpha_spaces"
              >
                <b-form-input
                  v-model="formulario.apellidoP"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Apellido paterno"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- APELLIDO MATERNO -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="apellido materno"
                rules="min:2|alpha_spaces"
              >
                <b-form-input
                  v-model="formulario.apellidoM"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Apellido materno"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- CORREO ELECTRÓNICO PERSONAL -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="correo personal"
                rules="required|email"
              >
                <b-form-input
                  v-model="formulario.email"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Correo electrónico personal"
                  @copy.prevent
                  @paste.prevent
                  @drag.prevent
                  @drop.prevent
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- CONFIRMACIÓN DE CORREO ELECTRÓNICO PERSONAL -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                rules="required|confirmed:correo personal"
                name="confirmación de correo"
              >
                <b-form-input
                  v-model="mailConfirm"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Confirme cuenta de correo electrónico"
                  @copy.prevent
                  @paste.prevent
                  @drag.prevent
                  @drop.prevent
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- CURP -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                rules="required|min:18|max:18"
                name="CURP"
              >
                <b-form-input
                  v-model="formulario.curp"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="CURP"
                  @input="formulario.curp = formulario.curp.toUpperCase()"
                  @copy.prevent
                  @paste.prevent
                  @drag.prevent
                  @drop.prevent
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- CONFIRMACIÓN DE CURP -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                rules="required|confirmed:CURP"
                name="confirmación de curp"
              >
                <b-form-input
                  v-model="curpConfirm"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Confirme su CURP"
                  @input="curpConfirm = curpConfirm.toUpperCase()"
                  @copy.prevent
                  @paste.prevent
                  @drag.prevent
                  @drop.prevent
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- TELÉFONO PERSONAL -->
          <b-col
            lg="6"
            sm="6"
            xs="12"
          >
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="teléfono personal"
                rules="required|digits:10"
              >
                <cleave
                  v-model="formulario.telefono"
                  class="form-control"
                  :class="{ 'is-invalid' : (errors.length > 0 ? false:null) == false }"
                  :raw="true"
                  :options="cleaveConfig"
                  :disabled="loader"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Teléfono personal"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- NO CONOCES TU CURP -->
          <b-col md="12">
            <p class="text-center">
              ¿No conoces tu CURP?
              <strong>
                <a
                  href="https://www.gob.mx/curp/"
                  target="__blank"
                >Consúltala aquí</a>
              </strong>
            </p>
          </b-col>
        </b-row>

        <!-- COMPONENTE DE DEPENDENCIAS -->
        <dependencias
          :resetea.sync="reseteadeps"
          @reseteaemit="reseteadeps=$event"
          @tipodegobierno="idtg=$event"
          @idestado="idef=$event"
          @idmunicipio="idmuni=$event"
          @iddependencia="iddp=$event"
        />

        <div class="my-2">
          <reason-field @on-value-change="formulario.carta_motivo = $event" />
          <advertising-field
            @on-select-change="formulario.medio_informativo = $event"
            @on-value-change="formulario.otro_medio = $event"
          />
          <checkbox-accept-terms @on-value-change="acceptTerms = $event" />
        </div>

        <!-- BUTTON -->
        <b-row class="mt-2">
          <b-col md="12">
            <b-button
              variant="primary"
              block
              :disabled="loader || !acceptTerms"
              @click.prevent="validationForm"
            >
              Enviar pre registro
            </b-button>

            <p
              v-if="!acceptTerms"
              class="mt-1 text-danger text-center"
            >
              <strong>Por favor, acepte los terminos referidos en la carta compromiso</strong>
            </p>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BCard,
  BFormInput,
  BFormGroup,
  BForm,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import {
  required, email, confirmed,
} from '@validations'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
// eslint-disable-next-line import/no-extraneous-dependencies
import 'cleave.js/dist/addons/cleave-phone.us'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import titleSection from '@/views/components/title-section.vue'
import dependencias from '@/views/components/dependencias/dependencia.vue'
import { postData } from '@core/utils/http/general'
import { isObject, isEmptyObject } from '@core/utils/utils'
import { ref, computed, watch } from '@vue/composition-api'
import CheckboxAcceptTerms from './components/CheckboxAcceptTerms.vue'
import ReasonField from './components/ReasonField.vue'
import advertisingField from './components/advertisingField.vue'

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BForm,
    BButton,
    BAlert,
    Cleave,
    ValidationProvider,
    ValidationObserver,
    titleSection,
    dependencias,
    CheckboxAcceptTerms,
    ReasonField,
    advertisingField,
  },
  props: {
    tbl: {
      type: String,
      required: true,
      default: null,
    },
    nla: {
      type: String,
      required: true,
      default: null,
    },
    userRol: {
      type: Object,
      required: true,
      default: () => {},
    },
    currentPlan: {
      type: Object,
      required: true,
      default: () => {},
    },
    successPreregisterProcess: {
      type: Function,
      required: true,
      default: () => {},
    },
    periodo: {
      type: Number,
      required: true,
      default: null,
    },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const form = ref(null)
    const counter = ref(1)
    const loader = ref(false)
    const mailConfirm = ref('')
    const curpConfirm = ref('')
    const cleaveConfig = { phone: true, phoneRegionCode: 'US' }
    const acceptTerms = ref(false)

    // FORM
    const formulario = ref({
      nombre: '',
      segundoNombre: '',
      apellidoP: '',
      apellidoM: '',
      telefono: '',
      email: '',
      curp: '',
      plan: props.currentPlan,
      periodo: props.periodo,
      carta_motivo: '',
      medio_informativo: null,
      otro_medio: null,
    })

    // VUE SELECT
    const dependenciasData = ref([])
    const idtg = ref(null)
    const idef = ref(null)
    const idmuni = ref(null)
    const iddp = ref(null)
    const reseteadeps = ref(null)

    // Hay dependencia seleccionada o municipio seleccionado
    const isDependencyOrCitySelected = computed(() => {
      const tipoGob = idtg.value?.id ?? null
      const municipio = idmuni.value?.id ?? null
      const dependencia = iddp.value?.id ?? null

      if (tipoGob === null) return false // No se ha seleccionado tipo de gobierno
      if ((tipoGob === 1 || tipoGob === 2) && dependencia === null) return false // Tipo de gobierno es federal o estatal (1 o 2), pero no hay dependencia seleccionada
      if (tipoGob === 3 && municipio === null) return false // Tipo de gobierno es municipal (3), pero no hay municipio seleccionado

      return true
    })

    const isSelectMedio = computed(() => (!!formulario.value.medio_informativo))

    // Clear form
    const clearForm = () => {
      formulario.value.nombre = null
      formulario.value.segundoNombre = null
      formulario.value.apellidoP = null
      formulario.value.apellidoM = null
      formulario.value.telefono = null
      formulario.value.email = null
      formulario.value.carta_motivo = null
      formulario.value.medio_informativo = null
      formulario.value.otro_medio = null
      delete formulario.value.entidadFederativa
      delete formulario.value.dependencia
      delete formulario.value.gob
      delete formulario.value.mun
      reseteadeps.value = true

      mailConfirm.value = ''
      curpConfirm.value = ''
    }

    // Submit form
    const submitForm = async () => {
      try {
        if (counter > 10) throw new Error('Ha superado la cantidad de intentos permitidos.')

        loader.value = true
        reseteadeps.value = false

        if (idtg.value !== null) formulario.value.gob = { id: idtg.value.id, nombre: idtg.value.nombre }
        else delete formulario.value.gob

        if (idef.value !== null) formulario.value.entidadFederativa = { id: idef.value.id, nombre: idef.value.nombre }
        else delete formulario.value.entidadFederativa

        if (idmuni.value !== null) formulario.value.mun = { id: idmuni.value.id, nombre: idmuni.value.nombre }
        else delete formulario.value.mun

        if (iddp.value !== null) formulario.value.dependencia = { id: iddp.value.id, nombre: iddp.value.nombre }
        else delete formulario.value.dependencia

        const userMail = formulario.value.email

        const params = new FormData()
        params.append('task', 'wspublico')
        params.append('origin', process.env.VUE_APP_ORIGIN_API)
        params.append('action', 4)
        params.append('tbl', props.tbl)
        params.append('nla', props.nla)
        params.append('data', JSON.stringify(formulario.value))

        if (props.userRol && props.userRol.id) params.append('rol', props.userRol.id)

        const { status, data } = await postData(params)

        emit('update-tbl', data.tbl) // Se actualiza tbl

        if (status !== 200 || data.status !== 200) throw new Error(data.message)

        const successConfigPreregisterMessage = {
          registerPath: `${data.token}/${data.fechaRegistro}`,
          controlEscolar: data.es_ce ?? false,
          esEstudiante: data.is_student ?? false,
          userMail,
        }

        props.successPreregisterProcess(successConfigPreregisterMessage)

        clearForm()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error on submit',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      } finally {
        counter.value += 1
        loader.value = false
      }
    }

    // Validate form
    const validationForm = async () => {
      try {
        const isValidate = await form.value.validate()

        if (!isValidate || !isDependencyOrCitySelected.value || !isSelectMedio.value) throw new Error('El formulario no cumple los requisitos mínimos requeridos para ser enviado.')

        formulario.value.segundoNombre = (formulario.value.segundoNombre === '') ? null : formulario.value.segundoNombre
        formulario.value.apellidoM = (formulario.value.apellidoM === '') ? null : formulario.value.apellidoM

        submitForm()
      } catch (error) {
        toast({
          component: ToastificationContent,
          props: {
            title: 'Validación de datos',
            text: error.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      }
    }

    // On each loader change state
    watch(loader, state => {
      emit('set-loader', state)
    })

    return {
      form,
      loader,

      // Form
      acceptTerms,
      mailConfirm,
      curpConfirm,
      formulario,
      cleaveConfig,
      validationForm,
      clearForm,

      // Dependencias
      dependenciasData,
      idtg,
      idef,
      idmuni,
      iddp,
      reseteadeps,

      // Validations
      required,
      isObject,
      isEmptyObject,
      email,
      confirmed,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
